export const client = {
    namespaced: true,
    state() {
        return {
            client: {},
        }
    },
    getters: {
        client: state => state.client,
    },
    mutations: {
        setClient(state, data) {
            state.client = data
        },
    },
    actions: {
        async saveClient({commit}, inertiaForm) {
            return new Promise(async (resolve, reject) => {
                inertiaForm.post('/clients', {
                    preserveScroll: true,
                    onSuccess: (data) => {
                        commit('setClient', data.props.flash.data)
                        resolve(data)
                    },
                    onError: (err) => {
                        reject(err)
                    },
                })
            })

        },
    },
}

